import { Badge, Box, Flex, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";

interface SideBarLinkProps {
  routeTo: string;
  icon?: React.ElementType;
  text: string;
  isExpanded: boolean;
  isTopicItem?: boolean;
  onClick?: () => void;
  notificationCount?: number;
}

export default function SideBarLinkComponent({
  routeTo,
  icon: Icon,
  text,
  isExpanded,
  isTopicItem,
  onClick,
  notificationCount,
}: SideBarLinkProps) {
  const location = useLocation();
  const isActive = location.pathname.startsWith(routeTo);
 
  return (
    <Link
      as={RouterLink}
      to={routeTo}
      onClick={onClick}
      w="100%"
      display="block"
      textDecoration="none"
      _hover={{ textDecoration: "none" }}
      fontFamily="Lexend Deca"
    >
      {isTopicItem ?
        <Flex
          height="50px" // 👈 um pouco menor
          alignItems="center"
          justifyContent={isExpanded ? "    flex-end" : "center"} // 👈 alinhado à direita
          gap={isExpanded ? "0.6rem" : "0"}
          padding={isExpanded ? "0 0 0 44px" : "0"}
          cursor="pointer"
          w="100%"
          fontWeight={isActive && isExpanded ? "bolder" : "normal"}
          fontSize={isActive && isExpanded ? "lg" : "sm"} // 👈 fonte menor
          transition="all 0.3s ease-in-out"
          _hover={{
            transform: isExpanded ? "scale(1.05)" : "none",
            boxShadow: "0 0 8px rgba(255, 255, 255, 0.2)",
            fontWeight: "bold",
            "& svg": {
              color: "white",
              fill: "white",
              stroke: "white",
            },
            "& p": {
              color: "white",
            },
          }}
        >
          {Icon && <Icon size="20px" color={isActive ? "#2c5282" : "white"} />}
          {/* {isExpanded && ( */}
          {isExpanded && (
            <Box width='100%' position='relative'>
              <Text
                color="white"
                fontFamily="Lexend Deca"
                transition="color 0.3s ease-in-out"
                fontSize="md" // 👈 menor fonte no texto
                textAlign="left" // 👈 texto alinhado à direita
                w="100%"
              >
                {text}
              </Text>
              {(notificationCount! > 0) && (
                <Badge px={1} rounded={4} position='absolute' top={-1} right={2} colorScheme='red'>{notificationCount}</Badge>
              )}

            </Box>
          )}
        </Flex>
        :
        <Flex
          height="60px"
          alignItems="center"
          justifyContent={isExpanded ? "flex-start" : "center"}
          gap={isExpanded ? "0.6rem" : "0"}
          padding={isExpanded ? "0 16px" : "0"}
          cursor="pointer"
          w="100%"
          fontWeight={isActive && isExpanded ? "bolder" : "normal"}
          fontSize={isActive && isExpanded ? "2xl" : "lg"}
          transition="all 0.3s ease-in-out"
          _hover={{
            transform: isExpanded ? "scale(1.1)" : "none",
            boxShadow: "0 0 10px rgba(255, 255, 255, 0.2)",
            fontWeight: "bold",
            fontSize: "lg",
            "& svg": {
              color: "white",
              fill: "white",
              stroke: "white",
            },
            "& p": {
              color: "white",
            },
          }}
        >
          {Icon && <Icon size="24px" color={isActive ? "#2c5282" : "white"} />}
          {isExpanded && (
            <Box width='100%' position='relative'>
              <Text
                color={isActive ? "white" : "white"}
                fontFamily="Lexend Deca"
                transition="color 0.3s ease-in-out"
              >
                {text}
              </Text>
              {(notificationCount! > 0) && (
                <Badge px={1} rounded={4} position='absolute' top={-1} right={6} colorScheme='red'>{notificationCount}</Badge>
              )}
            </Box>


          )}
        </Flex>
      }
    </Link>
  );
}
